import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1.5 w-full">
        {label && (
          <label className="text-xs font-bold text-slate-700 px-1">
            {label}
            {props.required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        <input
          ref={ref}
          className={`
            flex h-8 w-full rounded-lg border bg-white px-3 py-1 text-xs transition-all
            file:border-0 file:bg-transparent file:text-xs file:font-medium
            placeholder:text-slate-300 placeholder:font-medium
            focus:outline-none focus:ring-2 focus:ring-[#8dc63f]/20 focus:border-[#8dc63f]
            disabled:cursor-not-allowed disabled:opacity-50
            ${error ? 'border-red-500 ring-red-500/20' : 'border-slate-200'}
            ${className}
          `}
          {...props}
        />
        {error && <p className="text-xs font-semibold text-red-500 px-1 mt-0.5">{error}</p>}
        {helperText && !error && <p className="text-xs text-slate-400 px-1 mt-0.5">{helperText}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';



